import React from 'react'


function Banner() {
  return (
    <div className="container bg-darkVoilet">
      <div className='BannerImg text-center items-center py-12'>
       <h1 className='sm:text-4xl text-4xl py-4 text-white font-extrabold'>Boost your links today</h1>
       <button className='rounded-full bg-cyan px-8 py-2 my-4 text-white'>Get started</button>
       </div>
    </div>
  )
}

export default Banner